import RebateConfig from './rebate_config.vue';

export default RebateConfig;
